export default "__VITE_ASSET__DEZKYxLd__"